module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-photo-photo-data-65071ef3a081964013d35d1847c9b012.jpg";